/***
 * @file:
 * @author: yeqing.qi
 * @Date: 2021-06-15 16:44:31
 */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
@Component({
  selector: 'dt-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
})
export class TabComponent implements OnInit {
  copySelectedTab: number; // å¤å¶çé»è®¤æ°æ®

  iTime;

  @Input() model = 0; // å½åéä¸­çå¼ é»è®¤æ¯ç¬¬ä¸ä¸ª

  @Input() name = 'name'; // é»è®¤å±ç¤ºçkeyå¼

  @Input() tabs; // æ¥æ¶ çtabs

  @Input() endReturn = false; // æåè¿åæ¯å¦è¦è¯·æ±

  @Input() isReturnSame = false; // æ¯å¦è¿åç¸åç¹å»çåç´   é»è®¤æ¯ ä¸è¿å

  @Input() isDebounce = false; // æ¯å¦æ·»å é´éæä½ é»è®¤æ¯ ä¸æ·»å 

  @Input() debounceTime = 500; // æåä¸æ¬¡æ§è¡çé´éæ¶é´

  @Output() tabChange = new EventEmitter<any>();

  constructor() {
    this.copySelectedTab = this.model;
  }
  toggleTab(index: number, tab: any) {
    if (this.isDebounce) {
      const self = this;
      clearTimeout(this.iTime);
      this.model = index;
      self.iTime = setTimeout(() => {
        self.isReturnSameFn(index, tab);
      }, self.debounceTime);
    } else {
      this.isReturnSameFn(index, tab);
    }
  }
  // è¿åå¤ç
  isReturnSameFn(index, tab) {
    if (this.isReturnSame) {
      this.tabChange.emit({ index, tab });
    } else {
      if (this.copySelectedTab !== index) {
        this.model = index;
        this.tabChange.emit({ index, tab });
      } else {
        if (!this.endReturn) {
          this.tabChange.emit({ index, tab });
        }
      }
      this.copySelectedTab = JSON.parse(JSON.stringify(this.model ? this.model : 0));
    }
  }
  ngOnInit() {}
}
